// Note: to convert correct video files that can be used for scrolling video textures, use the following command:
// ffmpeg -i inputVideo.mp4 -c:v libx264 -preset slow -crf 22 -x264-params keyint=15 outputVideo.mp4
// related to /videos/cyber60-background.mp4`

const filePostfix = window.matchMedia("(max-width: 767px)").matches ? '-mobile' : '';
// const assets_uploads = 'https://lsvpstage.wpengine.com/wp-content/uploads';
export default [
    {
        name: 'videoTextureHero',
        type: 'videoTexture',
        path: `${ window.theme_assets_url }/images/cyber60-v2/cyber60-hero${ filePostfix }.mp4`
        // path: `${ assets_uploads }/2024/10/cyber60-hero${ filePostfix }.mp4`
    },
    {
        name: 'videoTextureBackground',
        type: 'videoTexture',
        path: `${ window.theme_assets_url }/images/cyber60-v2/cyber60-background${ filePostfix }.mp4`
        // path: `${ assets_uploads }/2024/10/cyber60-background${ filePostfix }.mp4`
    },
    /*{
        name: 'textureEnv',
        type: 'cubeTexture',
        path: `${ window.theme_assets_url }/images/cyber60-v2/env_map_1k.hdr`
    },
    {
        name: 'cyber60Model',
        type: 'gltfModel',
        path: `${ window.theme_assets_url }/models/cyber60-4.glb`
    }*/
]
